import React, { useEffect, useState } from "react";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import { useTableContext } from "../../../context/TableContext";
import OwnerPreFilters from "./OwnerPreFilters";
import PreFilterDefaultSort from "./PreFilterDefaultSort";
import PreFilterJoinedBy from "./PreFilterJoinedBy";
import PreFilterTable from "./PreFilterTable";
import { columnOperatorData, operatorData } from "./operatorData";

const PreFilter = ({
  preFilters,
  setPreFilters,
  ownerPreFilters,
  setOwnerPreFilters,
  table_id,
  type = "",
  prefiltersJoinedBy,
  setPrefiltersJoinedBy,
  activity_id = ""
}) => {
  const [tableData, setTableData] = useState(null);
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();

  const fetchTable = async () => {
    let { data, tableObject } = await getTableTypeData(applicationBlockData.table_type, table_id);
    setTableObj(tableObject);
    setTableData(data);
  };

  const setSortColumns = (data) => {
    const newLayout = JSON.parse(JSON.stringify(recordsviewLayout));
    newLayout.default_sort = data;
    setRecordsviewLayout(newLayout);
  };

  useEffect(() => {
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const folderIds = activity_id ? [activity_id] : [];
  return (
    <div className="prefilter_container tab_inside_container">
      {(applicationBlockData.table_type === "statemachine" || applicationBlockData.table_type === "rdbms") &&
        ownerPreFilters && (
          <OwnerPreFilters
            ownerPreFilters={ownerPreFilters}
            setOwnerPreFilters={setOwnerPreFilters}
            tableData={tableData}
          />
        )}
      {type === "recordview" && (
        <>
          <PreFilterDefaultSort
            tableObj={tableObj}
            blockType={applicationBlockData.table_type}
            defaultSort={recordsviewLayout.default_sort || []}
            setSortColumns={setSortColumns}
            tableId={table_id}
            folderIds={folderIds}
          />
        </>
      )}
      <label className="prefilter_label">Row Pre-filters</label>
      <PreFilterJoinedBy prefiltersJoinedBy={prefiltersJoinedBy} setPrefiltersJoinedBy={setPrefiltersJoinedBy} />
      <PreFilterTable
        preFilters={preFilters}
        setPreFilters={setPreFilters}
        tableId={table_id}
        folderId={activity_id}
        operatorList={[...operatorData, ...columnOperatorData]}
        tableObj={tableObj}
      />
    </div>
  );
};

const NewPrefilter = ({
  prefiltersWithFormula,
  handleChange,
  tableId,
  folderIds = [],
  tableType,
  filterValues = null,
  valueOptions = null,
  tableObject = null
}) => {
  const { getTableTypeData } = useTableContext();
  const [tableObj, setTableObj] = useState(tableObject || null);

  const fetchTable = async () => {
    let { tableObject } = await getTableTypeData(tableType, tableId);
    setTableObj(tableObject);
  };

  useEffect(() => {
    if (tableObject) {
      setTableObj(tableObject);
    }
  }, [tableObject]);

  useEffect(() => {
    if (tableObject) return;
    if (!tableId || !tableType) return;
    // if (filterValues && filterValues.length > 0) return;
    if (tableType === "http-template") return;
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!prefiltersWithFormula) return;
  const preFilters = prefiltersWithFormula.prefilter;
  const prefiltersJoinedBy = prefiltersWithFormula.prefilters_joined_by;

  const handleChangePrefilter = (type, data) => {
    handleChange(
      {
        ...prefiltersWithFormula,
        [type]: data
      },
      {
        type,
        data
      }
    );
  };
  return (
    <div>
      <PreFilterJoinedBy
        prefiltersJoinedBy={prefiltersJoinedBy}
        setPrefiltersJoinedBy={(newJoinedBy) => handleChangePrefilter("prefilters_joined_by", newJoinedBy)}
      />
      <PreFilterTable
        preFilters={preFilters}
        setPreFilters={(newPrefilters) => handleChangePrefilter("prefilter", newPrefilters)}
        tableId={tableId}
        folderId={folderIds}
        operatorList={[...operatorData, ...columnOperatorData]}
        tableObj={tableObj}
        filterValues={filterValues}
        valueOptions={valueOptions}
        tableType={tableType}
      />
    </div>
  );
};

export { NewPrefilter };

export default PreFilter;
